import React from 'react';
import { Button } from '@vds/buttons';
import './FloatingCart.css';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Title, Body, Micro } from '@vds/typography';
import CustomRow from './CustomRow';
import {
	Accordion,
	AccordionItem,
	AccordionHeader,
	AccordionDetail,
	AccordionTitle,
	AccordionSubTitle
} from '@vds/accordions';
import { PricingLockup } from '@vds/type-lockups';
import { MONTH_CHARGES, MONTH_CHARGES_KEYS } from '../../Pages/CustomizeOrder/containers/constants';
import { Loader } from '@vds/loaders';
import * as SiteAnalytics from '../../sitecatalyst';

const LockupWrapper = styled.div`
	display: flex;
`;

const StyledButton = styled(Button)`
    display: inline-block;
    margin-right: 15px;
    width: 11rem;
    @media only screen and (max-width: 600px) {
        margin: 5px 20px 5px 0;
        width: 139px;
    }
    span {
        margin: 0;
    }
`;

const FloatingCartPrintPDF = (props) => {
	const getFloatCartResponse = useSelector((state) => state.CustomizeOrder.getFloatCartResponse);
	const isSavedCartOfferApplied = useSelector((state) => state.CustomizeOrder.isSavedCartOfferApplied);
	const getPostLqData = useSelector((state) => state.CustomizeOrder.getPostLqData);
	const addressValidationPage = useSelector((state) => state.AddressValidationPage);
	const { headerInfo, BlueJeanInfo, dataInfo, offerInfo, phoneInfo, tvInfo, subTotals, otherServices, equipmentAndOnetimeCharges, equipmentAndOnetimeChargesTotal, taxAndOtherCharges, subTotalequipmentAndOnetimeCharges } = getFloatCartResponse?.planDetails;
	const offerPlanName = getFloatCartResponse?.planDetails?.offerInfo && getFloatCartResponse?.planDetails?.offerInfo[0] ? getFloatCartResponse.planDetails.offerInfo[0].planName : ''

	return (
		<div className="floating-cart bundle">
			<div id="print">
				<div style={{ padding: "10px 0" }}>
					<div style={{ marginLeft: "-2px" }}>
						<img height="41" width="189" className='ImageContent' src="images/v-logo.svg" />
					</div>
					<div>
						<div
							style={{
								fontSize: "24px",
								fontWeight: "bold",
								letterSpacing: 0,
								lineHeight: "24px",
								marginTop: "26px"
							}}
						>
							Your Cart
						</div>
					</div>
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", lineHeight: "16px", letterSpacing: 0 }}>
							Contact information
						</div>
						<div style={{ fontSize: "11px", lineHeight: "16px", letterSpacing: 0 }}>
							{addressValidationPage.emailAddress}
						</div>
						<div style={{ fontSize: "11px", lineHeight: "16px", letterSpacing: 0 }}>{addressValidationPage.phoneNumber}</div>
					</div>
					<div style={{ marginTop: "23px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", lineHeight: "16px", letterSpacing: 0 }}>Service address</div>
						<div style={{ fontSize: "12px", lineHeight: "16px", letterSpacing: 0 }}>{getPostLqData.Address.split(',')[0]}{','}</div>
						<div style={{ fontSize: "12px", lineHeight: "16px", letterSpacing: 0 }}>
							{getPostLqData.City}, {getPostLqData.State} {getPostLqData.Zip}
						</div>
					</div>
				</div>
				<div
					style={{
						marginTop: "26px",
						borderTop: "2px solid black",
						borderBottom: "1px solid black",
						paddingTop: "7px",
						paddingBottom: "6px",
					}}
				>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "16px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Estimate Month 1
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "16px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										{headerInfo?.Price}/ a month
									</div>
									<div style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
										Plus taxes &amp; fees.
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style={{ marginTop: "10px" }}>
					<div
						style={{ fontSize: "16px", fontWeight: "bold", letterSpacing: "0.5px" }}
					>
						Monthly service fees
					</div>
				</div>
				{(dataInfo && dataInfo?.planName) ? (
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: 0 }}>
							Internet service
						</div>
						<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
							<tbody>
								<tr>
									<td
										style={{
											width: "60%",
											textAlign: "left",
											border: "none",
											verticalAlign: "top",
										}}
									>
										<div style={{ fontSize: "12px", letterSpacing: 0 }}>
											{dataInfo.planName}
										</div>
									</td>
									<td
										style={{
											width: "40%",
											textAlign: "right",
											border: "none",
											verticalAlign: "top",
										}}
									>
										<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
											{headerInfo.isStandalone ? dataInfo.planPrice : "Included"}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>) : null}
				{phoneInfo ? (
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: 0 }}>
							Phone service
						</div>
						<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
							<tbody>
								{phoneInfo.lines ? (
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: 0 }}>
												{`Business Digital Voice - ${phoneInfo.noOfLines} line${phoneInfo.noOfLines > 1 ? 's' : ''}`}
											</div>
											{phoneInfo.lines?.map((item, i) => {
												return (
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														{item.TN
															? item.TN?.replace(
																/(\d{3})(\d{3})(\d{4})/g,
																'$1.$2.$3'
															)
															: ''}
													</div>)
											})}
										</td>
										<td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												{phoneInfo.planPrice}
											</div>
										</td>
									</tr>) : null}
								{phoneInfo.FaxLine?.length > 0 ? (
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: 0 }}>
												{`Standard line- ${phoneInfo.FaxLine?.length} line${phoneInfo.FaxLine?.length > 1 ? 's' : ''}`}
											</div>
											{phoneInfo.FaxLine.map((item, i) => {
												return (
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														{item.keyWord
															? item.keyWord?.replace(
																/(\d{3})(\d{3})(\d{4})/g,
																'$1.$2.$3'
															)
															: ''}
													</div>)
											})}
										</td>
										<td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												{phoneInfo.FaxLine[0].Price}
											</div>
										</td>
									</tr>) : null}
								{phoneInfo.phoneServices?.length ? (
									phoneInfo.phoneServices.map((item, i) => {
										return (
											<tr key={i}>
												<td
													style={{
														width: "60%",
														textAlign: "left",
														border: "none",
														verticalAlign: "top",
													}}
												>
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														{item.Name}
													</div>
												</td>
												<td
													style={{
														width: "40%",
														textAlign: "right",
														border: "none",
														verticalAlign: "top",
													}}
												>
													<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
														{item.Rc == 0 ? 'Included' : item.Rc}
													</div>
												</td>
											</tr>
										)
									})) : null}
							</tbody>
						</table>
					</div>) : null}
				{tvInfo ? (
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: 0 }}>
							TV service
						</div>
						<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
							<tbody>
								<tr>
									<td
										style={{
											width: "60%",
											textAlign: "left",
											border: "none",
											verticalAlign: "top",
										}}
									>
										<div style={{ fontSize: "12px", letterSpacing: 0 }}>
											{tvInfo.planName}
										</div>
									</td>
									<td
										style={{
											width: "40%",
											textAlign: "right",
											border: "none",
											verticalAlign: "top",
										}}
									>
										<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
											{headerInfo.isStandalone ? tvInfo.planPrice : "Included"}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>) : null}
				<div>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "12px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Subtotal services
									</div>
									<div style={{ fontSize: "11px", letterSpacing: 0 }}>
										Estimated monthly charges
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										{subTotals.services?.price}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				{otherServices?.length || tvInfo?.tvServices?.length || tvInfo?.MovieChannelsPack?.length ? (
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: 0 }}>
							Other Service
						</div>
						<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
							<tbody>
								{otherServices?.map((item, i) => {
									return (
										<tr>
											<td
												style={{
													width: "60%",
													textAlign: "left",
													border: "none",
													verticalAlign: "top",
												}}
											>
												<div style={{ fontSize: "12px", letterSpacing: 0 }}>
													{item.Product}
												</div>
											</td>
											<td
												style={{
													width: "40%",
													textAlign: "right",
													border: "none",
													verticalAlign: "top",
												}}
											>
												<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
													{item.ProdOfferDesc ? [<div key={i}>{item.price}</div>, <div>&nbsp;</div>] : <div key={i}>{item.price}</div>}
												</div>
											</td>
										</tr>)
								})}
								{tvInfo?.tvServices?.length ? (
									tvInfo.tvServices.map((item, i) => {
										return (
											<tr>
												<td
													style={{
														width: "60%",
														textAlign: "left",
														border: "none",
														verticalAlign: "top",
													}}
												>
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														{item.prdName}
													</div>
												</td>
												<td
													style={{
														width: "40%",
														textAlign: "right",
														border: "none",
														verticalAlign: "top",
													}}
												>
													<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
														{item.Price}
													</div>
												</td>
											</tr>)
									})) : null}
								{tvInfo?.MovieChannelsPack?.length ? (
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											{tvInfo && tvInfo.MovieChannelsPack?.length > 0 &&
												<div style={{ fontSize: "12px", letterSpacing: 0 }}>
													Movie Channels Pack
												</div>}
											{tvInfo?.MovieChannelsPack?.map((item, i) => {
												return (
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														{item.channelName}
													</div>)
											})}
										</td>
										<td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												{tvInfo.MoviechannelsPackPrice}
											</div>
											{tvInfo?.MovieChannelsPack?.map((item, i) => {
												return (
													<div style={{ fontSize: "12px", letterSpacing: 0 }}>
														Included
													</div>)
											})}
										</td>
									</tr>) : null}
							</tbody>
						</table>
					</div>) : null}
				<div>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "12px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Subtotal other services
									</div>
									<div style={{ fontSize: "11px", letterSpacing: 0 }}>
										Estimated monthly charges
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										{subTotals.otherServices?.price}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style={{ marginTop: "20px" }}>
					<div
						style={{ fontSize: "16px", fontWeight: "bold", letterSpacing: "0.5px" }}
					>
						One-time charges
					</div>
					<div style={{ fontSize: "12px" }}>
						Equipment purchases, activation and other fees can be billed as
						installment payments. You can make installment updates during checkout.
					</div>
				</div>
				<div style={{ marginTop: "10px" }}>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
						<tbody>
							{equipmentAndOnetimeCharges?.map((item, i) => {
								return (
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: 0 }}>
												{item.offerName}
											</div>
											{item.installmentOption &&
												<div style={{ fontSize: "11px", letterSpacing: 0 }}>
													{item.installmentOption}
												</div>}
										</td>
										<td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												{item.price ? item.price : "Fee Waived"}
											</div>
										</td>
									</tr>)
							})}
						</tbody>
					</table>
				</div>
				<div>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "12px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Subtotal one-time charges
									</div>
									<div style={{ fontSize: "11px", letterSpacing: 0 }}>
										Estimated monthly installment payments
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										{equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges.price}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style={{ marginTop: "10px" }}>
					<div
						style={{ fontSize: "16px", fontWeight: "bold", letterSpacing: "0.5px" }}
					>
						Taxes and other charges
					</div>
					<div style={{ fontSize: "12px" }}>
						Estimated taxes and fees. Sales taxes for equipment purchases may be
						applied for your first month. Regional Sports Network and other fees may
						apply.
					</div>
				</div>
				<div style={{ marginTop: "10px" }}>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
						<tbody>
							{taxAndOtherCharges?.taxAndotherCharges?.map((item, i) => {
								return (
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: 0 }}>
												{item.offerName}
											</div>
											{item.installmentOption &&
												<div style={{ fontSize: "11px", letterSpacing: 0 }}>
													{item.installmentOption}
												</div>}
										</td>
										<td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												{item.price ? item.price : "Fee Waived"}
											</div>
										</td>
									</tr>)
							})}
							{taxAndOtherCharges?.Tax?.Price !== "$0.00" ? <tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div style={{ fontSize: "12px", letterSpacing: 0 }}>
										{taxAndOtherCharges?.Tax?.Name}
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
										{taxAndOtherCharges?.Tax?.price}
									</div>
								</td>
							</tr> : null}
						</tbody>
					</table>
				</div>
				<div>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "12px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Subtotal taxes and other charges
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										{taxAndOtherCharges?.subTotalTaxCharges?.services?.price}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				{offerInfo && offerInfo.length ? (
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "16px", fontWeight: "bold", letterSpacing: "0.5px" }}>
							Promotional savings
						</div>
						<div style={{ fontSize: "12px" }}>
							Promotional offers and savings included with your selected service.
						</div>
					</div>
				) : null}
				{offerInfo?.length ? (offerInfo.map(item => {
					return (
						<div style={{ marginTop: "10px" }}>
							<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
								<tbody>
									<tr>
										<td
											style={{
												width: "60%",
												textAlign: "left",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: 0 }}>
												{item.planName}
											</div>
										</td>
										{false && <td
											style={{
												width: "40%",
												textAlign: "right",
												border: "none",
												verticalAlign: "top",
											}}
										>
											<div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
												$200.00
											</div>
										</td>}
									</tr>
								</tbody>
							</table>
						</div>
					)
				})) : null}
				{false && <div style={{ marginTop: "10px" }}>
					<table style={{ width: "100%", border: "none", borderSpacing: "0 0.5em" }}>
						<tbody>
							<tr>
								<td
									style={{
										width: "60%",
										textAlign: "left",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{ fontSize: "12px", letterSpacing: 0, fontWeight: "bold" }}
									>
										Subtotal promotional savings
									</div>
								</td>
								<td
									style={{
										width: "40%",
										textAlign: "right",
										border: "none",
										verticalAlign: "top",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											letterSpacing: "0.5px",
											fontWeight: "bold",
										}}
									>
										$200.00
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>}
				{false && <div style={{ marginTop: "10px" }}>
					<div style={{ fontSize: "12px" }}>
						<strong>*Technical Support Pro:</strong> First two months are included.
						Opt-in to receive support for $xx.xx per month starting on Month 3.
					</div>
				</div>}
				<div style={{ marginTop: "40px" }}>
					<div style={{ fontSize: "11px", color: "#747676" }}>
						Complete your order today to take advantage of the pricing and promotions
						now in effect. If you do not complete or cancel the order within 10 days,
						the order will be canceled automatically.
						<br />
						<br />
						Verizon is dedicated to protecting your privacy. Privacy Policy.
						<br />
						<br />
						© 2022 Verizon. All Rights Reserved. <br />
						<br />
						Verizon Services Corp. | One Verizon Way | Basking Ridge, NJ 07920
					</div>
				</div>
			</div>
		</div>
	);
};

export default FloatingCartPrintPDF;
